import { initAsideDrawer } from './../js/initAsideDrawer';
import {initScrollSpyActiveNav} from './../js/initScrollSpyActiveNav';

document.addEventListener("DOMContentLoaded", function(){
  const HEADER_OFFSET = 72; // sticky header height for anchor scroll
  const DESKTOP_MIN = 1024;

  initAsideDrawer({
    headerOffset: HEADER_OFFSET,
    desktopMin: DESKTOP_MIN,
    selectors: {
      toggle: '.anchor-links__toggle',
      aside: '.anchor-links__asside',
      close: '.anchor-links__asside-top-close',
      navLink: '.anchor-links__nav-link',
      navItem: '.anchor-links__nav-item',
    },
    classes: {
      open: 'is-open',
      bodyLocked: 'overflow-hidden',
      active: 'active',
    },
  });
   initScrollSpyActiveNav({
    headerOffset: HEADER_OFFSET,
    buffer: 100,
    desktopMin: DESKTOP_MIN,
    asideSelector: '.anchor-links__asside',
    navLinkSelector: '.anchor-links__nav-link',
    navItemSelector: '.anchor-links__nav-item',
    activeClass: 'active',
    respectHashOnInit: true,
  });
})
